import { useEffect } from "react";

import "react-datepicker/dist/react-datepicker.css";

import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { HStack, VStack } from "@chakra-ui/react";
import LoaderIndicator from "../components/loader_indicator";

import FiltersGrid from "../components/potential_page/filters_grid";
import PotentialTable from "../components/potential_page/potential_table";

const PotentialPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllPartnersPotential();
    pageStore.getAllAccountNumbers();
    pageStore.getAllYears();
    pageStore.updateSelectedPeriod("");
    pageStore.getAllBackups();
    pageStore.getAllPromos();
    pageStore.resetFilters();
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid renderButtons={(buttons) => buttons} />
        <PotentialTable data={pageStore.data_potentials} renderButtons={(buttons) => buttons} />
      </HStack>
    </VStack>
  );
});

export default PotentialPage;
